<jni-confirm-dialog
  [dialogMessage]="popupmessage"
  dialogHeading="Delete Confirmation"
  *ngIf="dialogStatus"
  (confirmDialogStatus)="confirmDialogStatusData($event)">
</jni-confirm-dialog>
<div class="gray-bg-rounded mb-75">
  <div class="whosupport mb-4">
    <div
      class="thead d-flex align-item-center justify-content-between px-0 mb-3">
      <h2 class="m-0">{{ gridheading }}</h2>
      <jni-spinner *ngIf="showSmallLoader"></jni-spinner>

      <!-- <a
      *ngIf="deletebuttonEnable"
      class="action-btn me-4"
      (click)="deleteDialog(gridheading)"
      >- Remove</a
    > -->

      <jni-support-user-list
        [datastatus]="gridheading"
        (userSupportMapDataEvent)="refreshTableData(gridheading)"
        (smallLoaderAddTableEvent)="smallLoaderCall($event)"
        [userAddTableData]="userProfileAddTableData"
        (deleteUserSupportEvent)="deleteDialog($event)"
        (deleteButtonEvent)="deleteButtonEnable($event)"
        (supportGridRightsEvent)="getUserRoleId($event)"
        [userId]="userId"
        #usersupportmap>
      </jni-support-user-list>
    </div>

    <p-table
      #dt
      stripedRows
      [value]="userProfileTableData"
      [rowHover]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 25, 50]"
      [paginator]="false"
      [size]="'small'"
      [scrollable]="true"
      scrollHeight="calc(100vh - 74vh)"
      [resizableColumns]="true"
      [loading]="loading"
      [filterDelay]="0"
      [(selection)]="selectedUsers"
      selectionMode="multiple"
      styleClass="table-listing usersupport-tble-calhgt">
      <ng-template pTemplate="header">
        <tr class="table-head">
          <th class="max-width-2"></th>
          <th *ngIf="gridheading === 'Who I Support'">Commissionable</th>
          <th *ngIf="gridheading === 'Who Supports Me'" class="max-width-6">
            Sales Team Members
          </th>
          <th>Active</th>
          <th>Primary</th>
          <th>Clients</th>
          <th>Quotes</th>
          <th>Orders</th>
          <th>CDI</th>
          <th>InvcPrv</th>
          <th>Ledger</th>
          <th class="max-width-5">Support %</th>
          <th class="max-width-5">Expires</th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-supportUserMapObj
        let-rowIndex="rowIndex">
        <tr
          class="p-selectable-row"
          [pSelectableRow]="supportUserMapObj"
          [pSelectableRowIndex]="rowIndex">
          <td class="col-center max-width-2">
            <p-tableCheckbox [value]="supportUserMapObj"></p-tableCheckbox>
          </td>
          <td
            *ngIf="gridheading === 'Who I Support'"
            (click)="
              onUserClickRedirect(
                supportUserMapObj?.user?.id,
                supportUserMapObj?.expiresOn
              )
            ">
            <a class="link">{{ supportUserMapObj?.user?.name }}</a>
          </td>
          <td
            class="max-width-6"
            *ngIf="gridheading === 'Who Supports Me'"
            (click)="
              onUserClickRedirect(
                supportUserMapObj?.supportUser?.id,
                supportUserMapObj?.expiresOn
              )
            ">
            <a class="link">{{ supportUserMapObj?.supportUser?.name }}</a>
          </td>
          <td>
            <p-checkbox
              #checkbox
              id="isActive"
              [(ngModel)]="supportUserMapObj.isSupportMapActive"
              (onChange)="onCheckboxStateChange(supportUserMapObj, $event)"
              inputId="isActive"
              [binary]="true"
              [disabled]="supportGridRights"
              [ngClass]="{
                'textboxcolor-blue': supportUserMapObj.isSupportMapActive,
              }"></p-checkbox>
          </td>
          <td>
            <p-checkbox
              #checkbox
              id="isPrimary"
              [(ngModel)]="supportUserMapObj.isPrimary"
              (onChange)="onCheckboxStateChange(supportUserMapObj, $event)"
              inputId="isPrimary"
              [binary]="true"
              [disabled]="supportGridRights"></p-checkbox>
          </td>
          <td>
            <p-checkbox
              #checkbox
              id="isClient"
              [(ngModel)]="supportUserMapObj.isClient"
              (onChange)="onCheckboxStateChange(supportUserMapObj, $event)"
              inputId="isClient"
              [binary]="true"
              [disabled]="supportGridRights"></p-checkbox>
          </td>

          <td>
            <p-checkbox
              #checkbox
              id="isQuotes"
              [(ngModel)]="supportUserMapObj.isQuotes"
              (onChange)="onCheckboxStateChange(supportUserMapObj, $event)"
              inputId="isQuotes"
              [binary]="true"
              [disabled]="supportGridRights"></p-checkbox>
          </td>
          <td>
            <p-checkbox
              #checkbox
              id="isOrder"
              [(ngModel)]="supportUserMapObj.isOrder"
              (onChange)="onCheckboxStateChange(supportUserMapObj, $event)"
              inputId="isOrder"
              [binary]="true"
              [disabled]="supportGridRights"></p-checkbox>
          </td>
          <td>
            <p-checkbox
              #checkbox
              id="isCDI"
              [(ngModel)]="supportUserMapObj.isCDI"
              (onChange)="onCheckboxStateChange(supportUserMapObj, $event)"
              inputId="isCDI"
              [binary]="true"
              [disabled]="supportGridRights"></p-checkbox>
          </td>
          <td>
            <p-checkbox
              #checkbox
              id="isInvcPrv"
              [(ngModel)]="supportUserMapObj.isInvcPrv"
              (onChange)="onCheckboxStateChange(supportUserMapObj, $event)"
              inputId="isInvcPrv"
              [binary]="true"
              [disabled]="supportGridRights"></p-checkbox>
          </td>
          <td>
            <p-checkbox
              #checkbox
              id="isLedger"
              [(ngModel)]="supportUserMapObj.isLedger"
              (onChange)="onCheckboxStateChange(supportUserMapObj, $event)"
              inputId="isLedger"
              [binary]="true"
              [disabled]="supportGridRights"></p-checkbox>
          </td>
          <td class="max-width-5">
            <p-inputnumber
              jniAutoCompleteBlocker
              [(ngModel)]="supportUserMapObj.support"
              (focusout)="onSupportPercentageFocusOutEvent(supportUserMapObj)"
              min="0"
              max="100"
              type="number"
              id="support"
              name="support"
              pInputText
              [disabled]="supportGridRights" />
          </td>
          <td class="max-width-5">
            <p-datepicker
              [(ngModel)]="supportUserMapObj.expiresOn"
              dateFormat="yy-mm-dd"
              (onSelect)="dateSelectionEvent(supportUserMapObj, $event)"
              (onClear)="dateSelectionEvent(supportUserMapObj, null)"
              [showClear]="true"
              onFocus="(this.type='date')"
              onBlur="if(!this.value) this.type='text'"
              [minDate]="currentdata"
              pInputText
              [disabled]="supportGridRights"
              [appendTo]="'body'"
              [ngClass]="{
                dateColorExpired: isExpiredDateValidation(
                  supportUserMapObj.expiresOn
                ),
                dateColorNotExpired: isGoingToExpired(
                  supportUserMapObj.expiresOn
                ),
              }" />
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
<!-- <jni-modal-stacker
  *ngIf="userDisplayModal"
  [displayModal]="userDisplayModal"
  (closeEvent)="closeUserModal()">
  <div class="panelBody">
    <jni-profile #profile [userId]="selectedUserId"></jni-profile>
  </div>
</jni-modal-stacker> -->
